'use client';

import { LINK } from '@constants';
import { ArrowRight, Column, Icon, Row, StampEmoji, Typography } from '@viewup/ui';
import { useCheckLogin } from 'app/_hook';

export const DefaultViewupStamp = () => {
  const checkLogin = useCheckLogin();
  return (
    <Row
      alignItems='center'
      css={{ cursor: 'pointer' }}
      justifyContent='space-between'
      onClick={() => checkLogin(LINK.STAMP)}
    >
      <Row alignItems='center' gap={16} height={60}>
        <StampEmoji />
        <Column gap={4}>
          <Typography color='text.assistance' fontType='body2.regular'>
            매일 출석체크하기
          </Typography>
          <Typography fontType='body2.medium'>
            오전, 오후 모두 출석하면{' '}
            <Typography color='text.interactive.info' fontType='body2.medium'>
              5P
            </Typography>
            를 드려요!
          </Typography>
        </Column>
      </Row>
      <Icon size='XS' source={ArrowRight} />
    </Row>
  );
};
